import { Button } from "@mui/material";
import { ConfirmDialog } from "components/ConfirmDialog";
import { ChemicalsWithMeasurementsQuery } from "generated-graphql/graphql";
import { DeleteChemicalMessage } from "./FacilityChemicalsTable";

type MeasurementType =
  ChemicalsWithMeasurementsQuery["facilityChemicalMeasurementsForReport"]["items"][number];
interface Props {
  measurementToDelete?: MeasurementType;
  setDeletingChemicalMeasurements: (value: MeasurementType | undefined) => void;
  handleDelete: (id: string, addZeroMeasurement?: boolean) => void;
  isDeleting: boolean;
  reportingYear: number;
}

export const DeleteChemicalMeasurementsConfirmDialog: React.FC<Props> = ({
  measurementToDelete,
  setDeletingChemicalMeasurements,
  handleDelete,
  isDeleting,
  reportingYear,
}) => {
  if (!measurementToDelete) return null;

  if (measurementToDelete.hasCarryOver) {
    return (
      <ConfirmDialog
        open={!!measurementToDelete}
        onClose={() => setDeletingChemicalMeasurements(undefined)}
        header="Are you sure you want to delete this chemical measurement?"
        resources={[
          {
            resourceType: "Chemical Measurement",
            resourceName: measurementToDelete.name,
          },
          {
            resourceType: "Reporting Year",
            resourceName: reportingYear,
          },
        ]}
        info={`You are deleting all measurements of this chemical. Choose to either retain the carryover amount from the previous year or reset the chemical amount to 0 on January 1, ${reportingYear}.`}
        actions={
          <>
            <Button
              disabled={isDeleting}
              loading={isDeleting}
              onClick={() => handleDelete(measurementToDelete.id, true)}
            >
              {`Reset to 0 on January 1, ${reportingYear}`}
            </Button>
            <Button
              loading={isDeleting}
              disabled={isDeleting}
              onClick={() => handleDelete(measurementToDelete.id, false)}
              data-testid="confirm"
            >
              {`Retain Carryover Amount`}
            </Button>
          </>
        }
        loading={isDeleting}
      />
    );
  } else {
    return (
      <ConfirmDialog
        open={!!measurementToDelete}
        onClose={() => setDeletingChemicalMeasurements(undefined)}
        onConfirm={() => handleDelete(measurementToDelete.id)}
        header="Are you sure you want to delete this chemical measurement?"
        resources={[
          {
            resourceType: "Chemical Measurement",
            resourceName: measurementToDelete.name,
          },
          {
            resourceType: "Reporting Year",
            resourceName: reportingYear,
          },
        ]}
        info={
          <DeleteChemicalMessage
            chemicalName={measurementToDelete.name}
            forMeasurements={true}
          />
        }
        loading={isDeleting}
      />
    );
  }
};
